var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmedSearchNew = function SvgConfirmedSearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.308 42.6H11.117l12.991-8.941 5.25 3.641 5.367-3.725 2.333 1.617a11.4 11.4 0 0 1 1.392-2.283l-1.384-.959L50.7 22.484v6.4c.941.266 1.833.65 2.666 1.133V18.6H5.358v26.667h31.925a11.2 11.2 0 0 1-.975-2.667m11.467-21.333L29.367 34.05 10.958 21.267zM8.033 22.484l13.75 9.55-13.75 9.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.558 50.226c-5.634 0-10.225-4.584-10.225-10.225 0-5.642 4.583-10.225 10.224-10.225 5.642 0 10.225 4.583 10.225 10.225S53.2 50.225 47.558 50.225m0-17.784c-4.167 0-7.559 3.392-7.559 7.559s3.392 7.558 7.558 7.558 7.559-3.392 7.559-7.558-3.392-7.559-7.559-7.559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.043 43.75a.7.7 0 0 1-.4-.133l-3.8-2.825.916-1.242 3.092 2.3 4.158-5.6 1.242.917-4.692 6.316a.64.64 0 0 1-.433.259h-.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.043 44.25c-.25 0-.5-.083-.709-.242l-4.191-3.116 1.516-2.042 3.092 2.3 4.158-5.6 2.05 1.508-4.991 6.717a1.14 1.14 0 0 1-.767.458c-.05 0-.108.009-.158.009z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export { SvgConfirmedSearchNew as Icon };
export default __webpack_public_path__ + "static/media/7986a1c421cf84fff4eb42c68659ceb7.svg";